import { Container } from '../../layout/flex-grid';
import { Type } from '@uswitch/spark';
import { RichText } from '../../../entry/page';
import { getVariantPath } from '@uswitch/ev-utils/lib/get-variant-path';
import { useMeta } from '@uswitch/ev-utils/lib/context/selectors';
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
import { jsx as _jsx } from "theme-ui/jsx-runtime";
export var stylePath = function stylePath(field) {
  return getVariantPath({
    atomicType: 'compounds',
    componentId: 'author-snippet',
    field: field
  });
};

var AuthorSnippet = function AuthorSnippet(_ref) {
  var snippet = _ref.snippet,
      author = _ref.name,
      url = _ref.url;

  var _useMeta = useMeta(['authorSnippet', 'press'], {}),
      mainPage = _useMeta.mainPage,
      page = _useMeta.page,
      pressUrl = _useMeta.url;

  return _jsx(Container, {
    children: _jsxs("div", {
      sx: {
        variant: stylePath('container')
      },
      children: [_jsxs(Type.H3, {
        sx: {
          variant: stylePath('title')
        },
        children: ["About ", author]
      }), _jsx(RichText, {
        content: snippet
      }), _jsxs(Type.Body1, {
        children: ["View ", _jsxs("a", {
          href: url,
          children: [author, "'s full biography here"]
        }), " or visit the ", mainPage, ' ', _jsx("a", {
          href: pressUrl,
          children: page
        }), " for our latest news."]
      })]
    })
  });
};

export default AuthorSnippet;